import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { PawPrint, ArrowRight } from "@phosphor-icons/react";

// Additive tribute section: a hypercolor PHOTOMOSAIC of Smiley (thousands of rescue-dog tiles)
// with King's face faded into the shadow. Every tile = a life worth saving.
const MOSAIC = "https://static.prod-images.emergentagent.com/jobs/062e260e-b0f9-432f-a759-5890d554bb91/images/7ab77e8dc0c57b1d6a518da691ce829a1939adc0a4d515406a9a8569f3f5b3f3.jpeg";

export default function PackMosaic() {
  return (
    <section className="relative py-24 bg-black overflow-hidden" data-testid="pack-mosaic">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-center">
        {/* Mosaic */}
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="relative rounded-2xl overflow-hidden border border-primary/30 neon-glow group"
          data-testid="pack-mosaic-image-wrap">
          <img src={MOSAIC} alt="Smiley — a photomosaic of a thousand rescue dogs, with King faded into the shadow"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
            className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
            data-testid="pack-mosaic-image" />
          <div className="absolute inset-0 pointer-events-none"
            style={{ background: "radial-gradient(120% 90% at 30% 30%, transparent 55%, rgba(0,0,0,0.55) 100%)" }} />
          <span className="absolute bottom-4 left-4 overline px-3 py-1.5 rounded-full bg-black/60 backdrop-blur text-primary border border-primary/40">
            1,000 rescues · 1 smile
          </span>
        </motion.div>

        {/* Story */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="text-left">
          <span className="overline text-secondary inline-flex items-center gap-2 mb-4">
            <PawPrint weight="fill" size={16} /> The Pack Mosaic
          </span>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mb-6">
            A thousand faces.<br />
            <span className="neon-text">One smile.</span>
          </h2>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Look close. Smiley's grin is built from a thousand tiny pit bulls and rescue animals —
            every square a life that deserved a couch, a name, a chance. Step back and it's the
            boy himself, the white pit with the softest soul.
          </p>
          <p className="text-muted-foreground leading-relaxed mb-8">
            And in the shadow behind him? That's King — never gone, just faded into the aura,
            watching over the pack.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/rescue" className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-[10px] font-modern font-medium hover:bg-primary/90 transition-colors" data-testid="pack-mosaic-rescue-cta">
              <PawPrint weight="fill" size={18} /> Meet the Guardian Wall
            </Link>
            <Link to="/shop" className="inline-flex items-center gap-2 border border-white/20 text-white px-6 py-3 rounded-[10px] font-modern hover:border-primary/50 hover:text-primary transition-colors" data-testid="pack-mosaic-story-cta">
              Shop the Season <ArrowRight size={16} />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
